import { Box, Typography } from "@mui/material"
import { DateField, TextField, useRecordContext, useTranslate } from "react-admin"
import { InvoiceReadModel, InvoiceReminderReadModel, InvoiceType } from "../../../GeneratedClients/FreeBillApi"

const InvoiceInfoComponent = () => {
  const translate = useTranslate()
  const record = useRecordContext<InvoiceReadModel | InvoiceReminderReadModel | any>()
  if(!record) return null

  return (
    <Box textAlign={'end'}>

      {
        record.invoiceNumber &&
        <Typography variant="body2">
          {translate(record.invoiceType === InvoiceType.ReverseInvoice ? 'resources.invoices.reverseInvoiceNumber' : 'resources.invoices.invoiceNumber')}: { record.invoiceNumber ? <TextField source="invoiceNumber" /> : "Entwurf"}
        </Typography>
      }
      {
        record.invoiceReminderDate &&
        <Typography variant="body2">
          {translate('resources.invoiceReminders.invoiceReminderDate')}: <DateField source="invoiceReminderDate" />
        </Typography>
      }
      {
        record.invoiceDate &&        
        <Typography variant="body2">
          {translate('resources.invoices.invoiceDate')}: <DateField source="invoiceDate" />
        </Typography>
      }
      {
        record.dueDate &&
        <Typography variant="body2">
          {translate('resources.invoices.dueDate')}: <DateField source="dueDate" />
        </Typography>
      }
    </Box>
  )
}

export default InvoiceInfoComponent